/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Topic_WedgeInputs */

const en_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const es_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const de_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const zh_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挖起杆`)
};

const ar_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الويدج`)
};

const fr_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const vi_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const sw_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const th_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวดจ์`)
};

const bs_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const ja_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウェッジ`)
};

const ko_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`웨지`)
};

const pt_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const it_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const sv_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const nl_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const da_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const nb_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const fi_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const pl_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const ru_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Веджи`)
};

const tr_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const hi_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेज`)
};

const id_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const ms_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const cs_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const el_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const he_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`וֶדג׳`)
};

const af_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

const hu_practice_topic_wedge = /** @type {(inputs: Practice_Topic_WedgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedge`)
};

/**
* | output |
* | --- |
* | "Wedge" |
*
* @param {Practice_Topic_WedgeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_topic_wedge = /** @type {((inputs?: Practice_Topic_WedgeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Topic_WedgeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_topic_wedge(inputs)
	if (locale === "de") return de_practice_topic_wedge(inputs)
	if (locale === "zh") return zh_practice_topic_wedge(inputs)
	if (locale === "ar") return ar_practice_topic_wedge(inputs)
	if (locale === "fr") return fr_practice_topic_wedge(inputs)
	if (locale === "vi") return vi_practice_topic_wedge(inputs)
	if (locale === "sw") return sw_practice_topic_wedge(inputs)
	if (locale === "th") return th_practice_topic_wedge(inputs)
	if (locale === "bs") return bs_practice_topic_wedge(inputs)
	if (locale === "ja") return ja_practice_topic_wedge(inputs)
	if (locale === "ko") return ko_practice_topic_wedge(inputs)
	if (locale === "pt") return pt_practice_topic_wedge(inputs)
	if (locale === "it") return it_practice_topic_wedge(inputs)
	if (locale === "sv") return sv_practice_topic_wedge(inputs)
	if (locale === "nl") return nl_practice_topic_wedge(inputs)
	if (locale === "da") return da_practice_topic_wedge(inputs)
	if (locale === "nb") return nb_practice_topic_wedge(inputs)
	if (locale === "fi") return fi_practice_topic_wedge(inputs)
	if (locale === "pl") return pl_practice_topic_wedge(inputs)
	if (locale === "ru") return ru_practice_topic_wedge(inputs)
	if (locale === "tr") return tr_practice_topic_wedge(inputs)
	if (locale === "hi") return hi_practice_topic_wedge(inputs)
	if (locale === "id") return id_practice_topic_wedge(inputs)
	if (locale === "ms") return ms_practice_topic_wedge(inputs)
	if (locale === "cs") return cs_practice_topic_wedge(inputs)
	if (locale === "el") return el_practice_topic_wedge(inputs)
	if (locale === "he") return he_practice_topic_wedge(inputs)
	if (locale === "af") return af_practice_topic_wedge(inputs)
	if (locale === "hu") return hu_practice_topic_wedge(inputs)
	return en_practice_topic_wedge(inputs)
});